import React from 'react';
import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import moment from 'moment';

export const DateTimeAttribute = ({
    value,
    required,
    placeholder,
    readOnly,
    className,
    onChange,
    onBlur,
}: {
    value?: string,
    required?: boolean,
    placeholder?: string,
    readOnly?: boolean,
    className?: string,
    onChange: (value: any) => void,
    onBlur: () => void
}) => {
    const handleDateChange = (date: any) => {
        const parsedDate = moment(date, 'DD-MM-YYYY HH:mm', true);
        onChange(parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD HH:mm') : '');
    };

    return (
        <DateTime
            value={value ? moment(value, 'YYYY-MM-DD HH:mm').format('DD-MM-YYYY HH:mm') : ''}
            dateFormat="DD-MM-YYYY"
            timeFormat="HH:mm"
            inputProps={{
                required,
                readOnly,
                placeholder,
                className: `form-control form-control-sm ${className || ''}`,
                onBlur
            }}
            onChange={handleDateChange}
        />
    );
};